import reduxFetch from 'react-redux-fetch';
import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';
import apiRoutes from '../../../app/api/routes';

const IDENTITY_PRINCIPALS_RESOURCE = 'identityPrincipals';

const identityPrincipalsService = ComposedComponent =>
  reduxFetch([
    {
      resource: IDENTITY_PRINCIPALS_RESOURCE,
      method: 'get',
      request: (identityId, t) => ({
        url: apiRoutes.identityPrincipals(identityId),
        clearValueOnRequest: true,
        meta: {
          id: identityId,
          toaster: {
            onErrorMessage: createErrorMessage(t, 'errorLoadingPrincipals'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default identityPrincipalsService;
export { IDENTITY_PRINCIPALS_RESOURCE };
